// extracted by mini-css-extract-plugin
export default {"welcomeSection":"WelcomeKontakt_welcomeSection__MZb0i","welcomeContainer":"WelcomeKontakt_welcomeContainer__8JCgE","welcomeText":"WelcomeKontakt_welcomeText__ZWbD8"};